import BaseAPI from '../base'

function getEntries(cafe_id) {
    return BaseAPI.get(`/auditlog/cafe/entries/${cafe_id}`)
}

function writeEntry(cafe_id, type, payload) {
    return BaseAPI.post(`/auditlog/cafe/write/${cafe_id}`, {
        type,
        payload
    })
}

export default {
    getEntries,
    writeEntry
}